module.exports = __webpack_public_path__ + "static/img/replacement-icon_dark.6159b2e4.png";